import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { StageService } from './stage.service';

@Injectable()
export class HandrailDisplayService {

  loadingStatus: boolean = false;
  needHandrailChange = new Subject<any>();
  handrailSubj = new Subject<any>()

  constructor(
    private stageService: StageService
  ) {
  }

  checkTiersStairsOnStage(){
    const compoundFloor =  this.stageService.getCompoundFloor();
    const stairs = this.stageService.getStairs();
    if (compoundFloor.children.length > 1 || stairs.length) {
      this.needHandrailChange.next(true);
    } else {
      this.needHandrailChange.next(false);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/handrail-display.service.ts